<div *ngIf="showTicketConditions" class="flight-details-box" [@toggleAnimation]>
  <div class="flight-details-box-wrapp">
    <h4 class="box-title">
      <span class="title">Ticket conditions</span>
      <button
        (click)="hideTicketConditions()"
        class="transition-all close-button">
        <span class="glyphicon glyphicon-remove"></span>
      </button>
    </h4>

    <div class="flight-details-box-content">
      <div>
        <ng-templete [ngSwitch]="!!fareRules">
          <ng-templete *ngSwitchCase="false">
            <p>
              {{ ticketConditons }}
            </p>
          </ng-templete>
          <p *ngSwitchCase="true" [innerHTML]="fareRules | addNewLine"></p>
        </ng-templete>
      </div>
    </div>
  </div>
</div>
